import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { LandingPageTemplate as template } from './landing-page.template';
import { LandingPageStyles as styles } from './landing-page.styles';
import { Route } from '@microsoft/fast-router';
import Lottie from 'lottie-web';
import { animation } from './animation';


const name = 'landing-page';

@customElement({
name,
template,
styles,
})
export class LandingPage extends FASTElement {
    @observable heroAnimation: HTMLElement;
    @observable whyCascadeTiles = [
        {
            heading: 'Heading',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.',
        },
        {
            heading: 'Heading',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.',
        },
        {
            heading: 'Heading',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.',
        }
    ];

    @observable links = [
        {
            linkText: 'Terms of Use',
        },
        {
            linkText: 'Privacy Information',
        },
        {
            linkText: 'Cookie Policy',
        },
        {
            linkText: 'Platform',
        },
        {
            linkText: 'Recourses',
        },
        {
            linkText: 'Company',
        },
        {
            linkText: 'Careers',
        },
        {
            linkText: 'Contact Us',
        },
    ];

    connectedCallback(): void {
        super.connectedCallback();
        var animationItem = Lottie.loadAnimation({
            container: this.heroAnimation,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animation
        })
    }

    public login() {
        Route.path.push(`welcome`);
    }
}
